module.exports = __webpack_public_path__ + "static/media/04_fear_cornelius_carstens.390351e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/fear/04_fear_cornelius_carstens.mp4
// module id = gYO/
// module chunks = 1